import React from 'react';
import ServiceCard from '../components/ServiceCard';
import './Services.css';

const services = [
  { title: 'Tire Collection', description: 'We collect used tires from your location.' },
  { title: 'Recycling', description: 'We recycle tires into reusable products.' },
  { title: 'Disposal', description: 'We ensure that tires are disposed of safely and responsibly.' },
];

const Services: React.FC = () => {
  return (
    <div className="services">
      <h1>Our Services</h1>
      <div className="service-cards">
        {services.map((service, index) => (
          <ServiceCard key={index} title={service.title} description={service.description} />
        ))}
      </div>
    </div>
  );
};

export default Services;
